import { useActiveGames } from "@/lib/game";
import { GameIcon } from "@/components/GameIcon";

/**
 * Barra de pestañas delgadas por juego para segmentar listados por juego
 * en Buyer/Seller/Admin dashboards. Estilo consistente con las tabs del
 * catálogo y publicar (border-bottom colored per game).
 *
 * Reactivo al flag backend `yugioh_enabled` vía `useActiveGames()` → preview
 * ve Yu-Gi-Oh, prod no.
 *
 * Uso:
 *   <GameTabs value={game} onChange={setGame} withAll testidPrefix="buyer-orders" />
 */
export function GameTabs({ value, onChange, withAll = true, testidPrefix = "game-tabs", className = "" }) {
  const activeGames = useActiveGames();
  const tabs = withAll
    ? [{ key: "all", label: "Todos", color: "#EF4444" }, ...activeGames]
    : activeGames;
  return (
    <div
      className={`flex items-center gap-1 border-b border-[#262626] overflow-x-auto ${className}`}
      data-testid={`${testidPrefix}-game-tabs`}
      role="tablist"
    >
      {tabs.map((g) => (
        <button
          key={g.key}
          type="button"
          role="tab"
          aria-selected={value === g.key}
          data-testid={`${testidPrefix}-game-tab-${g.key}`}
          onClick={() => onChange(g.key)}
          className={`inline-flex items-center gap-1.5 px-3 py-2 text-xs sm:text-sm font-medium whitespace-nowrap transition-colors border-b-2 ${value === g.key ? "text-white" : "border-transparent text-neutral-500 hover:text-white"}`}
          style={value === g.key ? { borderColor: g.color, color: "#fff" } : undefined}
        >
          {g.key !== "all" && <GameIcon game={g.key} size="xs" />}
          <span>{g.label}</span>
        </button>
      ))}
    </div>
  );
}

export default GameTabs;
